// src/utils/orderTypeUtils.js
//
// "Aidel New Wig" and "Aidel Wig Repair" are the exact same services as
// "New Wig" and "Wig Repair" — they only exist as separate order types so the
// Aidel brand can be filtered/reported on separately. Every business rule
// (payment minimums, tax, customer agreement, warranty, wig requirements,
// deposit handling) must treat the branded types identically to their base
// type. Use normalizeOrderType() wherever an order type drives a rule; keep the
// original value for storage, display, and reporting.

const AIDEL_ORDER_TYPE_ALIASES = {
  'Aidel New Wig': 'New Wig',
  'Aidel Wig Repair': 'Wig Repair',
};

/**
 * Maps a branded order type to its base type for rule evaluation.
 * Unmapped values (and empty/undefined) pass through unchanged.
 * @param {string} orderType
 * @returns {string}
 */
export const normalizeOrderType = (orderType) =>
  AIDEL_ORDER_TYPE_ALIASES[orderType] || orderType || '';

/** True for "New Wig" and "Aidel New Wig". */
export const isNewWigOrder = (orderType) =>
  normalizeOrderType(orderType) === 'New Wig';

/** True for "Wig Repair" and "Aidel Wig Repair". */
export const isWigRepairOrder = (orderType) =>
  normalizeOrderType(orderType) === 'Wig Repair';

export default { normalizeOrderType, isNewWigOrder, isWigRepairOrder };
